import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {AgentsModule} from "../../agents/angular/agents.module";
import {FormsModule} from "@angular/forms";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {NgSelectModule} from "@ng-select/ng-select";
import {BranchesMultiSelectComponent} from "./components/branches-multi-select/branches-multi-select.component";
import {
  BranchesMultiSelectListComponent
} from "./components/branches-multi-select-list/branches-multi-select-list.component";

@NgModule({
  declarations: [
    BranchesMultiSelectComponent,
    BranchesMultiSelectListComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    AddressesModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    AgentsModule,
    FormsModule,
    NgSelectModule
  ],
  providers: [],
  exports: [
    BranchesMultiSelectComponent
  ]
})

export class BranchesModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapBranchesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(BranchesModule);
};

export const downgradedBranchesModule = downgradeModule(bootstrapBranchesModule);
